import styled from 'styled-components';
import { Button, Tabs } from '@tryhackme/thm-ui-components';

export const StyledSkillDetailsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  h3 {
    font-size: 2.4rem;
    color: white;
    margin-bottom: 0.8rem;
  }

  p {
    color: ${({ theme }) => theme.colors.grey[500]};
  }

  button svg {
    width: 1.8rem;
    height: 3.6rem;
    align-items: flex-start;

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;
export const StyledFilterHeader = styled.header`
  position: sticky;
  top: -2.4rem;
  z-index: 2;
  padding-bottom: 1rem;
  background: rgb(33, 44, 66);
`;

export const StyledTab = styled(Tabs)`
  margin-top: 2.4rem;

  button,
  button[data-state='active'] {
    color: ${({ theme }) => theme.colors.white};
  }

  button:hover {
    background-color: ${({ theme }) => theme.colors.secondary.main};
  }

  ul {
    margin-top: 0.8rem;
  }
`;

export const StyledTabsFilterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 3.42rem;
  align-items: center;
  margin-bottom: 2.4rem;
`;

export const StyledTypeButton = styled(Button)<{ $isSelected?: boolean }>`
  border-radius: 100px;
  padding: 0.8rem 1.6rem;
  border: 1px solid ${({ theme }) => theme.colors.secondary.lighter};
  svg {
    width: 1.4rem;
  }

  ${({ $isSelected, theme }) =>
    $isSelected &&
    `
    background-color: ${theme.colors.secondary.lighter};
    border-color: ${theme.colors.secondary.lighter};
    color: ${theme.colors.white};
  `}
`;
